import { ACTION_SET_TOKENS } from "./names";

export default function tokenInfo(state = {}, action) {
  switch (action.type) {
    case ACTION_SET_TOKENS:
      return action.payload;

    default:
      return state;
  }
}
